//@flow

import React from 'react';
import { useDispatch } from 'react-redux';
import { ButtonPrimary } from 'texkit/dist/components/Buttons';

import Modal from '../Modal';
import Trans from '../../Trans/Trans';
import { closeModal } from '../../../../reducers/modal/modalActions';
import './dl-id-scan-error-modal.scss';

type Props = {
  onClose?: Function,
};

const MODAL_NAME = 'DLIDScanErrorModal';

const DLIDScanErrorModal = ({ onClose }: Props) => {
  const dispatch = useDispatch();

  return (
    <Modal
      name={MODAL_NAME}
      className="dl-id-scan-error-modal"
      onClose={onClose}
      disableOnClickOutside
    >
      <h2 className="dl-id-scan-error-title">
        <Trans
          file="CreateAccount"
          id="SomethingWentWrong"
          fallback="Something went wrong"
        />
      </h2>
      <p className="dl-id-scan-error-description">
        <Trans
          file="Labels"
          id="ScanErrorDescription"
          fallback="Please try again or enter your information manually."
        />
      </p>
      <ButtonPrimary
        type="button"
        className="dl-id-scan-error-button"
        onClick={() => dispatch(closeModal(MODAL_NAME))}
      >
        <Trans file="Labels" id="okGotItConfirm" fallback="OK, got it" />
      </ButtonPrimary>
    </Modal>
  );
};

export default DLIDScanErrorModal;
